const es = {
    views: {
        userList: {
            age: 'Edad',
            name: 'Nombre',
            gender: 'Sexo',
            country: 'Pais',
            email: 'Correo',
            cell: 'Móvil',
            phone: 'Teléfono',
            actions: 'Acciones',
            address: 'Dirección',
            donwloadTitle: 'Descargar CSV',
            donwloadConfirm: '¿Está seguro que desea descargarlo?',
            userCsvName: 'Usuario',
            favUserCsvName: 'Usuarios favoritos',
            getApiUsers: 'Obtener usuarios de la api',
            nickname: 'Apodo',
            uploadFavUserList: 'Subir lista de usuarios',
            noUserTitle: 'Por favor carge los datos de la api',
        },
        currentUser: {
            position: 'Posición: ',
            age: 'Edad: ',
            name: 'Nombre: ',
            gender: 'Sexo: ',
            country: 'Pais: ',
            email: 'Correo: ',
            cell: 'Móvil: ',
            phone: 'Teléfono: ',
            actions: 'Acciones: ',
            address: 'Dirección: ',
            noUserTitle: 'Por favor seleccione un usuario en la tabla',
        },
    },
    common: {
        titles: {
            favUserTable: 'Usuarios Favoritos',
            userTable: 'Usuarios',
            home: 'Inicio',
            user: 'Usuario',
            es: 'Español',
            en: 'Inglés',
            translations: 'Traducciones',
            apiFavUserTable: 'Usuarios API favoritos',
        },
        notifications: {
            errorMessage: 'Ha habido un error',
            uploadFavUsers: 'Lista de usuarios subida correctamente',
            getUsers: 'Usuarios cargados correctamente',
            getFavUsers: 'lista de usuarios fav cargados correctamente',
        },
    },
};

export default es;
